<template>
  <v-container fluid grid-list-sm>
    <oops v-if="showOops" :rowType="rowType" />
    <v-container v-else fluid>

      <v-row dense>
        <v-col cols="12">
          <v-progress-linear v-if="showProgress" :indeterminate="true" color="accent" :active="showProgress" height="2">
          </v-progress-linear>
        </v-col>
      </v-row>

      <!--Title fills whole top of screen------>
      <v-row dense>
        <v-col>
          <big-title v-if="itemReason" :item-reason="itemReason" :row-type="rowType" :auth="auth"></big-title>
        </v-col>
      </v-row>

      <!--Film stuff----->
      <v-row dense>
        <!--the film player and assets------>
        <v-col xs="12" md="6">
          <v-row dense>
            <v-col cols="12">
              <v-card flat>
                <big-film :item-reason="itemReason" use-player :row-type="rowType" :editing="editing" :auth="auth"
                  :dirty="dirty" :master="useMaster"></big-film>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <!--the film master details such as thumbnails etc----->
        <v-col xs="12" md="6">
          <v-row dense>
            <v-col cols="12">
              <v-card flat>
                <v-card-title>
                  Film Master Details and content analysis
                </v-card-title>

                <v-card-text>
                  <v-select :items="masterItems" :label="`${mastersCountText}`" :disabled="mastersCount < 2"
                    v-model="modelActiveMasterID" select></v-select>
                </v-card-text>

                <v-card-text v-if="useMaster && useMaster.masterTitle">
                  Original title: <b>{{ useMaster.masterTitle }}</b>
                </v-card-text>

                <v-card-text>
                  <v-select :items="labelTypes" label="Content navigator" dense v-model="labelNav" item-text="text"
                    item-value="value"></v-select>
                </v-card-text>

                <div v-if="showSpotTracking">
                  <spots :label-nav="labelNav" :float-rate="floatRate" :duration="duration" :filmMasterID="useMasterID">
                  </spots>
                </div>

                <big-labels v-if="itemReason" :item-reason="itemReason" use-player :row-type="rowType" :auth="auth"
                  @refreshfilm="refreshFilm" :dirty="dirty" :master="useMaster"></big-labels>

              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row dense>
        <!--the film detail----->
        <v-col xs="12" md="6">
          <v-row dense>
            <v-col>
              <v-card flat>
                <content-table v-if="film" :items="[itemReason]" :contentHeading="contentHeading" :item-type="rowType"
                  item-name="Film"></content-table>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <!--the content detail----->
        <v-col md="6" sm="12">
          <v-row dense>
            <v-col>
              <v-card flat>
                <big-content :row-types="rowTypes" :item="item"></big-content>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

      </v-row>

    </v-container>
  </v-container>
</template>
<script>
import Contenttable from "@/components/Contenttable";
import Bigcontent from "@/components/Bigcontent";
import Bigfilm from "@/components/Bigfilm";
import Biglabels from "@/components/Biglabels";
import Bigtitle from "@/components/Bigtitle";
import oops from "@/components/Oops";
import { FilmPage, Controls } from "@/gql";
import { mergeControls } from "@/js/apollo";
import { SearchUtils } from "@/js";
import { vxMaps } from "@/js/vxstore";
import { settings } from '@/js/store'
import { mapState, mapMutations } from 'vuex'
import spots from '@/components/Spots'
const { labelTypes } = settings.viLabels
export default {
  components: {
    "content-table": Contenttable,
    "big-content": Bigcontent,
    "big-title": Bigtitle,
    "big-film": Bigfilm,
    "big-labels": Biglabels,
    spots,
    oops,
  },
  props: {
    auth: Object,
  },
  methods: {
    sortRows(rows) {

      if (!rows || !rows.length) return rows

      const sorted = [...rows].sort((a, b) => {
        const aRaw = (a.master.masterTitle || '').trim()
        const bRaw = (b.master.masterTitle || '').trim()
        const aUpper = aRaw.toUpperCase()
        const bUpper = bRaw.toUpperCase()

        const getTier = (upper) => {
          if (upper === '' || upper === 'UNTITLED') return 3
          if (upper.startsWith('SP0')) return 2
          if (upper.includes('UNTITLED')) return 1
          return 0
        }

        const aTier = getTier(aUpper)
        const bTier = getTier(bUpper)

        // 1. Sort by Priority Tier
        if (aTier !== bTier) {
          return aTier - bTier
        }

        // 2. Secondary Sort: Alphabetical within the same tier
        return aUpper.localeCompare(bUpper, undefined, {
          numeric: true,
          sensitivity: 'base',
        })
      })


      return sorted

    },
    refreshFilm() {
      this.$apollo.queries.FilmPage.refetch();
      this.dirty = true;
    },
    clearFilm() {
      // this prevents the wrong posterframe being shown
      this.clearStack();
      this.setSlideIndex(-1);
    },
    ...mapMutations(vxMaps.mutations),
  },
  watch: {
    Controls(val) {
      if (val.refresh) {
        this.$apollo.queries.FilmPage.refetch();
        mergeControls({
          refresh: false,
        });
      }
    },

    film: {
      immediate: true,
      handler() {
        this.clearFilm();
      },
    },
  },
  data: () => ({
    labelNav: labelTypes && labelTypes.find(f => f.text === 'Shots').value,
    labelTypes: [{ text: 'None', value: 'none' }].concat(labelTypes),
    rowTypes: ["award", "person", "brand", "product", "company"],
    dirty: false,
    amID: null
  }),
  computed: {
    floatRate() {
      return this.playerStats.floatRate
    },
    showSpotTracking() {
      return this.labelNav !== 'none'
    },
    duration() {
      return this.useMaster && this.useMaster.duration
    },
    modelActiveMasterID: {
      get() {
        return this.useMasterID;
      },
      set(val) {
        this.amID = val;
      },
    },
    masters() {
      return this.film && this.film.FilmMasters;
    },
    mastersCount() {
      return this.masterItems && this.masterItems.length;
    },
    mastersCountText() {
      const m = typeof this.mastersCount === typeof undefined || this.mastersCount === null ? 'checking for' : this.mastersCount
      return `${m} master(s)${this.filmName ? ' for ' + this.filmName : ''}`
    },
    firstMasterItem() {
      return this.masterItems && this.masterItems[0];
    },
    firstMaster() {
      return this.firstMasterItem && this.firstMasterItem.master
    },
    activeMaster() {
      return this.amID && this.masters.find((f) => f.id === this.amID);
    },
    useMaster() {
      return this.activeMaster || this.firstMaster
    },
    useMasterID() {
      return this.useMaster && this.useMaster.id
    },
    masterItems() {
      return this.sortRows(
        this.masters &&
        this.masters.map((f) => {
          // those generated by apps script use base 36
          // identifiable because they are compound
          const gas = f.runID.indexOf("-") !== -1;
          const d = SearchUtils.getDateFromRunID({
            runID: f.runID,
            base: gas ? 36 : 32,
            size: gas ? 8 : 9,
          });
          const v =
            f.provenance &&
            f.provenance.variant &&
            f.provenance.variant.replace(/^[\W]+?/, "");
          const variant = v || f.masterTitle ? `${f.masterTitle}` : "";
          return {
            text: `${variant} (via ${f.hostUserName
              } on ${SearchUtils.formatDate(d)} - duration ${f.duration}s)`,
            value: f.id,
            master: f,
          };
        })
      )
    },
    contentHeading() {
      return "Film details";
    },
    rowType() {
      return "film";
    },
    filmName() {
      return this.film && this.film.filmName;
    },
    film() {
      return this.itemReason && this.itemReason.Film;
    },
    editing() {
      return this.params && this.params.editing;
    },
    passedItem() {
      return this.params.item;
    },
    showOops() {
      return !this.itemMake && !this.$apollo.loading;
    },
    showProgress() {
      return this.itemMake && !this.itemMake.big;
    },
    item() {
      return this.itemMake && this.itemMake.item;
    },
    itemMake() {
      // make the award query look like a reason from the summary page
      // but if we are coming from a awardpage, we'll already have some of what we need
      // so use that to start building thepage while the query is still in progress
      let item = SearchUtils.makeSearcherFromFilm(this.FilmPage);

      if (item) {
        return {
          item,
          big: true,
        };
      }
      if (!this.passedItem) {
        return null;
      }
      // we got one, so make it look like it was the result of a search
      item = this.passedItem;
      if (this.rowType !== item.itemType) {
        console.log(`expected ${this.rowType} but got item ${item.itemType}`);
      }
      return {
        item,
      };
    },
    params() {
      return this.$route.params;
    },
    id() {
      return this.params.id;
    },
    itemReason() {
      return this.item && this.item.itemReason;
    },
    ...mapState(vxMaps.state),
  },
  apollo: {
    Controls: {
      query: Controls,
    },
    FilmPage: {
      query: FilmPage,
      variables() {
        return {
          id: this.id,
        };
      },
    },
  },
};
</script>
